import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ChatConversation from "@/components/ChatConversation";
import { XIcon, SparkleIcon, ArrowSquareOutIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function ChatWidget() {
  const { user, ready } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [conversation, setConversation] = useState(null);

  // Don't show on auth pages
  const hidden = !ready || !user || pathname === "/login" || pathname === "/register" || pathname === "/chat";

  const ensureConversation = async () => {
    try {
      const { data } = await api.get("/chat/conversations");
      if (data && data.length > 0) {
        setConversation(data[0]);
      } else {
        const res = await api.post("/chat/conversations", { title: "New chat" });
        setConversation(res.data);
      }
    } catch (e) {
      console.warn("ChatWidget: failed to load/create conversation", e);
    }
  };

  useEffect(() => {
    if (open && !conversation) ensureConversation();
  }, [open]); // eslint-disable-line

  if (hidden) return null;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          data-testid="open-chat-widget"
          aria-label="Open Ask AI"
          className="fixed bottom-6 right-6 z-40 w-16 h-16 flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
        >
          <img src="/igpt-logo.png" alt="" className="w-full h-full object-contain drop-shadow-lg" />
        </button>
      )}

      {open && (
        <div
          data-testid="chat-widget"
          className="fixed bottom-6 right-6 z-40 w-[420px] max-w-[90vw] h-[560px] max-h-[80vh] flex flex-col bg-white border border-border rounded-sm shadow-2xl"
        >
          <div className="px-3 py-2 border-b border-border flex items-center justify-between bg-[#0A0A0A] text-white">
            <div className="flex items-center gap-2">
              <SparkleIcon size={14} weight="fill" className="text-emerald-400" />
              <div className="font-display font-bold text-sm tracking-tight">Ask AI</div>
              <span className="text-[10px] font-mono text-white/40">Claude Sonnet 4.5</span>
            </div>
            <div className="flex items-center gap-1">
              <Link to="/chat" onClick={() => setOpen(false)} data-testid="open-full-chat" title="Open full chat" className="p-1 hover:bg-white/10 rounded-sm">
                <ArrowSquareOutIcon size={12} />
              </Link>
              <button onClick={() => setOpen(false)} data-testid="close-chat-widget" className="p-1 hover:bg-white/10 rounded-sm">
                <XIcon size={12} weight="bold" />
              </button>
            </div>
          </div>
          <div className="flex-1 min-h-0">
            {conversation ? (
              <ChatConversation conversation={conversation} compact />
            ) : (
              <div className="h-full flex items-center justify-center text-xs text-zinc-500">Loading…</div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
